// src/security-report.tsx
import { createSvgIcon } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var SecurityReportIcon = createSvgIcon(
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      d: "M17 .629H2a1.5 1.5 0 0 0-1.5 1.5v5.51c0 8.402 7.108 11.188 8.531 11.66.304.104.634.104.938 0 1.425-.473 8.531-3.26 8.531-11.661v-5.51a1.5 1.5 0 0 0-1.5-1.5Zm0 7.011c0 7.352-6.22 9.809-7.5 10.236C8.232 17.454 2 15 2 7.64V2.13h15V7.64ZM8.75 9.63v-3.75a.75.75 0 1 1 1.5 0v3.75a.75.75 0 1 1-1.5 0Zm-.375 3.375a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
    }
  ),
  "SecurityReportIcon"
);

export {
  SecurityReportIcon
};
